import { createContext, useContext } from 'react';
export const SpeakersContext = createContext({});
export const useSpeakersContext = () => useContext(SpeakersContext);
